export default "__VITE_ASSET__101a4725__"